import { TableColumnsType } from 'reducer/processingTaskReducer';
import { PAGINATION } from 'utils/constants';
import { TKeys } from 'utils/enums';

export const paginateDefault: Pagination = {
    page: 1,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

export const tableColumns = (
    tableType: TableColumnsType = TableColumnsType.List,
): DataGridColumn[] => {
    switch (tableType) {
        case 'table_detals':
            return [
                {
                    title: TKeys.LBL150062,
                    titleAlign: 'left',
                    field: 'container_id',
                },
                {
                    title: TKeys.LBL150063,
                    titleAlign: 'left',
                    field: 'content_name',
                },
                {
                    title: TKeys.LBL150064,
                    titleAlign: 'left',
                    field: 'task_amount',
                },
                {
                    title: TKeys.LBL150065,
                    titleAlign: 'left',
                    field: 'comment',
                },
                {
                    title: TKeys.LBL150066,
                    titleAlign: 'left',
                    field: 'images',
                    columnDataType: 'link',
                },
            ];

        default:
            return [
                { title: TKeys.LBL150001, titleAlign: 'left', field: 'task_id' },
                {
                    title: TKeys.LBL150002,
                    titleAlign: 'left',
                    field: 'task_category_name',
                },
                {
                    title: TKeys.LBL150003,
                    titleAlign: 'left',
                    field: 'task_content_name',
                },
                { title: TKeys.LBL150004, titleAlign: 'left', field: 'status' },
                { title: TKeys.LBL150005, titleAlign: 'left', field: 'responsible_user_name' },
                { title: TKeys.LBL150006, titleAlign: 'left', field: 'company_name' },
                { title: TKeys.LBL150007, titleAlign: 'left', field: 'location_name' },
                {
                    title: TKeys.LBL150008,
                    titleAlign: 'left',
                    field: 'planned_date',
                },
                { title: TKeys.LBL150009, titleAlign: 'left', field: 'create_at' },
                { title: TKeys.LBL150010, titleAlign: 'left', field: 'input_done_date' },
                {
                    title: TKeys.LBL150011,
                    titleAlign: 'left',
                    field: 'done_date_output',
                },
            ];
    }
};

export const processingStatuses = (t: (key: string) => string) => [
    { id: 0, name: t(TKeys.LBL150092) },
    { id: 1, name: t(TKeys.LBL150093) },
    { id: 2, name: t(TKeys.LBL150094) },
    { id: 3, name: t(TKeys.LBL150095) },
    { id: 4, name: t(TKeys.LBL150096) },
];

export enum ProcessStatus {
    NotProcessed = 0, // 未処理
    ProcessingStarted = 1, // 処理投入中
    ProcessingSubmitted = 2, // 処理投入完了
    ProcessingCompleted = 3, // 処理完了
    Deleted = 4, // 削除済
}
